module.exports = __webpack_public_path__ + "static/1-9ebb3f6908ee048dfbba48d62682d2af.jpeg";